import React,{ useRef, useState } from "react";
import { FileIcon } from "../../assets/svgs/icons-svg";

// ── File Dropzone ─────────────────────────────────────────────────────────────
export function FileDropzone({ file, onChange, label }: { file: File | null; onChange: (f: File) => void; label?: string }) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setDragging(false);
    const dropped = e.dataTransfer.files[0];
    if (dropped) onChange(dropped);
  };

  return (
    <div
      onClick={() => inputRef.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={handleDrop}
      className={`border-2 border-dashed rounded-lg p-6 flex items-center gap-4 cursor-pointer transition-colors duration-200 ${
        dragging ? "border-gray-500 bg-gray-50" : "border-gray-300 bg-white hover:bg-gray-50"
      }`}
    >
      <FileIcon />
      <div className="text-sm text-gray-500">
        {file ? (
          <span className="text-gray-800 font-medium">{file.name}</span>
        ) : (
          <>
            <span>Drag and drop file/picture or </span>
            <span className="font-semibold text-gray-900">click here to upload</span>
            <p className="text-xs text-gray-400 mt-0.5">.pdf, .docx, .txt formats (5 MB max)</p>
          </>
        )}
      </div>
      <input ref={inputRef} type="file" accept=".pdf,.docx,.txt,image/*" className="hidden" onChange={(e) => { if (e.target.files?.[0]) onChange(e.target.files[0]); }} />
    </div>
  );
}